import { configureStore } from "@reduxjs/toolkit"

import { apiSlice } from "@/store/apis/api.slice"

import { writeFormSessionMiddleware } from "@/store/form/form.slice"

import rootReducer from "./reducer"

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production" ? { trace: true } : false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Matrix / RTK Query cache can be large; default 32ms threshold spams dev console
      serializableCheck: { warnAfter: 128 },
      immutableCheck: { warnAfter: 128 },
    })
      .concat(apiSlice.middleware)
      .concat(writeFormSessionMiddleware.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Removed to keep the actions at a minimum for now
// but can look to reinstate later if needed
// setupListeners(store.dispatch)

export default store
